import {gql} from 'apollo-angular';


export var get_graph_event = gql`
    query getEvent($id: ID!, $calendar: ID!, $user: ID!){
      getGraphEvent(id: $id, calendar: $calendar, user: $user){
        id
        subject
        location
        attendees
      }
    }
`

export var post_graph_event = gql`
    mutation createGraphEvent($outlook_event_type_id: ID!, $attendees:[ID!], $company_event_id: ID!, $event_datetime: Mixed!){
      createGraphEvent(outlook_event_type_id: $outlook_event_type_id, attendees: $attendees, company_event_id: $company_event_id, event_datetime: $event_datetime){
        id
        isCancelled
        attendees
      }
    }
`

export var update_graph_event = gql`
    mutation updateGraphEvent(
      $attendees: [ID!],
      $event_id: ID!,
      $company_event_id: ID!,
      $outlook_event_type_id: ID!,
      $calendar: ID!,
      $user: ID!,
      $event_datetime: Mixed!
      $attendees_only: Boolean!
    ){
      updateGraphEvent(
        attendees:$attendees,
        event_id: $event_id,
        company_event_id: $company_event_id,
        outlook_event_type_id: $outlook_event_type_id,
        calendar: $calendar,
        user: $user,
        event_datetime: $event_datetime
        attendees_only: $attendees_only
      ){
        id
        attendees
      }
    }
`

export var delete_graph_event = gql`
    mutation deleteGraphEvent($id: ID!, $calendar: ID!, $user: ID!){
      deleteGraphEvent(id: $id, calendar: $calendar, user: $user){
        id
      }
    }
`

export var cancel_graph_event = gql`
    mutation cancelGraphEvent($id: ID!, $calendar: ID!, $user: ID!){
      cancelGraphEvent(id: $id, calendar: $calendar, user: $user){
        id
      }
    }
`
